import src from "IMAGE";
export default { src, width: 1390, height: 40, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAJElEQVR42mMQE5NRERWRUhIUlNLl5OSTZIACHR1do5MnL7wCADD6BXdmjqwuAAAAAElFTkSuQmCC"};
